import {
  Heading,
  Avatar,
  Box,
  Image,
  Flex,
  Stack,
  Button,
  useColorModeValue,
  SimpleGrid,
  Badge,
  useToast,
  Text,
  VStack,
  HStack,
  Divider,
  Icon,
  Card,
  CardBody,
  CardHeader,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Container,
  useClipboard,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
} from "@chakra-ui/react";
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaPhone,
  FaEnvelope,
  FaBriefcase,
  FaUsers,
  FaNewspaper,
  FaShare,
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaCopy,
  FaCheckCircle,
} from "react-icons/fa";
import CatNavbar from "./CatNavbar";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import ProductCardProfile from "./ProductCards/ProductCardProfile";
import NotListedAnything from "./resources/NotListedAnything";
import Loading from "./resources/Loading";

export default function SearchProfile() {
  const { useremail } = useParams();
  const [profileData, setProfileData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const bgcolor1 = useColorModeValue("white", "gray.800");
  const bgcolor2 = useColorModeValue("#151f21", "gray.900");
  const [products, setProducts] = useState([]);
  const [visibleproducts, setVisibleProducts] = useState(6);
  const hasMoreProductsToLoad = visibleproducts < products.length;
  const loggedInUserId = localStorage.getItem('userId');
  const [friendStatus, setFriendStatus] = useState(''); // '', 'friends', 'pending', 'requested'
  const toast = useToast();
  
  // Color scheme
  const textColor = useColorModeValue("gray.700", "gray.200");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const highlightColor = useColorModeValue("green.500", "green.300");
  const cardShadow = useColorModeValue("sm", "dark-lg");
  const gradientBg = useColorModeValue(
    "linear(to-r, green.400, blue.500)",
    "linear(to-r, green.600, blue.700)"
  );
  
  // Share functionality
  const currentUrl = window.location.href;
  const shareTitle = `${profileData.name}'s Profile - AgroManch`;
  const shareText = `Check out ${profileData.name}'s profile on AgroManch`;
  
  const { onCopy, hasCopied } = useClipboard(currentUrl);

  if (useremail === localStorage.getItem("authemail")) {
    window.location.href = "/profile";
  }
  useEffect(() => {
    axios
      .get(`https://api.agromanch.com/profilesearch?useremail=${useremail}`)
      .then((response) => {
        setProfileData(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });

    const getProducts = async () => {
      try {
        const response = await axios.get(
          `https://api.agromanch.com/getProductsbyemail?useremail=${useremail}`
        );
        setProducts(response.data);
        setIsLoading(false);
      } catch (err) {
        console.error(err);
        setIsLoading(false);
      }
    };
    getProducts();
  }, []);

  useEffect(() => {
    const checkFriendStatus = async () => {
      if (!profileData._id || !loggedInUserId) return;
      try {
        const [friendsRes, requestsRes] = await Promise.all([
          axios.get(`https://api.agromanch.com/api/friends/list/${loggedInUserId}`),
          axios.get(`https://api.agromanch.com/api/friends/requests/${profileData._id}`)
        ]);
        const isFriend = friendsRes.data.some(f => f._id === profileData._id);
        const isPending = requestsRes.data.some(r => r._id === loggedInUserId);
        setFriendStatus(isFriend ? 'friends' : isPending ? 'pending' : '');
      } catch {
        setFriendStatus('');
      }
    };
    checkFriendStatus();
  }, [profileData._id, loggedInUserId]);

  const handleShare = (platform) => {
    const encodedUrl = encodeURIComponent(currentUrl);
    const encodedText = encodeURIComponent(shareText);
    const encodedTitle = encodeURIComponent(shareTitle);

    let shareUrl = '';
    
    switch (platform) {
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      default:
        return;
    }
    
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
  };

  const handleCopyLink = () => {
    onCopy();
    toast({
      title: "Link Copied!",
      description: "Profile link has been copied to clipboard.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const PostCard = ({ post }) => (
    <Card bg={bgcolor1} borderRadius="lg" boxShadow={cardShadow} mb={4}>
      <CardHeader pb={2}>
        <HStack>
          <Avatar size="sm" src={post.user?.picture} name={post.user?.name} />
          <VStack align="start" spacing={0}>
            <Text fontWeight="bold" fontSize="sm">{post.user?.name}</Text>
            <Text fontSize="xs" color="gray.500">{formatDate(post.createdAt)}</Text>
          </VStack>
        </HStack>
      </CardHeader>
      <CardBody pt={0}>
        {post.content && <Text mb={3}>{post.content}</Text>}
        {post.image && (
          <Image 
            src={post.image} 
            alt="Post image" 
            borderRadius="md" 
            maxH="600px"
            objectFit="cover"
            w="100%"
          />
        )}
        <HStack mt={3} spacing={4}>
          <HStack>
            <Icon as={FaUsers} color="gray.500" boxSize={4} />
            <Text fontSize="sm" color="gray.500">{post.likes && Array.isArray(post.likes) ? post.likes.length : 0} likes</Text>
          </HStack>
          <HStack>
            <Icon as={FaNewspaper} color="gray.500" boxSize={4} />
            <Text fontSize="sm" color="gray.500">{post.comments?.length || 0} comments</Text>
          </HStack>
        </HStack>
      </CardBody>
    </Card>
  );

  const handleAddFriend = async () => {
    try {
      await axios.post('https://api.agromanch.com/api/friends/request', { fromUserId: loggedInUserId, toUserId: profileData._id });
      setFriendStatus('pending');
      toast({ title: 'Friend request sent', status: 'success', duration: 2000, isClosable: true });
    } catch {
      toast({ title: 'Failed to send request', status: 'error', duration: 2000, isClosable: true });
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  const name = profileData.name;
  const picture = profileData.picture || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

  return (
    <Container maxW="container.xl" py={6}>
      {/* Profile Header */}
      <Card
        bg={bgcolor1}
        borderRadius="xl"
        boxShadow={"xl"}
        overflow="hidden"
        mb={6}
        position="relative"
      >
        {/* Cover Image */}
        <Box 
          h={{ base: "150px", md: "200px" }}
          bgGradient={gradientBg}
          position="relative"
        >
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bgImage="url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3')"
            bgSize="cover"
            bgPosition="center"
            opacity={0.3}
          />
        </Box>
        
        <CardBody>
          <Flex direction={{ base: "column", md: "row" }} align={{ base: "center", md: "flex-end" }} mt={-20}>
            

            <img style={{ width: "150px", height: "150px", borderRadius: "50%", zIndex:'100' }} src={picture} alt="" />
            
            {/* Profile Info */}
            <VStack align={{ base: "center", md: "flex-start" }} flex={1} spacing={2}>
              <HStack>
                <Heading size={{ base: "lg", md: "xl" }} color={textColor}>
                  {profileData.name}
                </Heading>
                {profileData.isEmailVerified && (
                  <Icon as={FaCheckCircle} color="green.500" boxSize={5} />
                )}
              </HStack>
              
              {profileData.isBusinessman && (
                <Badge colorScheme="green" px={3} py={1} borderRadius="full">
                  <Icon as={FaBriefcase} mr={1} />
                  {profileData.businessCategory || 'Businessman'}
                </Badge>
              )}
              
              <HStack spacing={4} flexWrap="wrap">
                {(profileData.city || profileData.state) && (
                  <HStack>
                    <Icon as={FaMapMarkerAlt} color={highlightColor} />
                    <Text fontSize="sm" color={textColor}>
                      {[profileData.area, profileData.city, profileData.state].filter(Boolean).join(', ')}
                    </Text>
                  </HStack>
                )}
                
                {profileData.joinedDate && (
                  <HStack>
                    <Icon as={FaCalendarAlt} color={highlightColor} />
                    <Text fontSize="sm" color={textColor}>
                      Joined {formatDate(profileData.joinedDate)}
                    </Text>
                  </HStack>
                )}
              </HStack>
              
              {/* Stats */}
              <HStack spacing={6} mt={2}>
                <VStack spacing={0}>
                  <Text fontWeight="bold" fontSize="lg" color={highlightColor}>
                    {profileData.totalPosts || 0}
                  </Text>
                  <Text fontSize="sm" color="gray.500">Posts</Text>
                </VStack>
                <VStack spacing={0}>
                  <Text fontWeight="bold" fontSize="lg" color={highlightColor}>
                    {products.length}
                  </Text>
                  <Text fontSize="sm" color="gray.500">Products</Text>
                </VStack>
               
              </HStack>
            </VStack>
            
            
          </Flex>
        </CardBody>
      </Card>
      
      {/* Content Tabs */}
      <Tabs variant="enclosed" colorScheme="green">
        <TabList>
          <Tab>Products ({products.length})</Tab>
          <Tab>Posts ({profileData.posts?.length || 0})</Tab>
        </TabList>
        
        <TabPanels>
          {/* Products Tab */}
          <TabPanel px={0}>
            {products.length === 0 ? (
              <NotListedAnything />
            ) : (
              <Box>
                <SimpleGrid columns={{ sm: 1, md: 2, lg: 3 }} spacing={4}>
                  {products.slice(0, visibleproducts).map((ad, index) => (
                    <ProductCardProfile key={index} ad={ad} />
                  ))}
                </SimpleGrid>
                {hasMoreProductsToLoad && (
                  <Button
                    mt={6}
                    bgGradient="linear(to-r, teal.400, cyan.600)"
                    color="white"
                    _hover={{
                      bgGradient: "linear(to-r, teal.600, cyan.800)",
                    }}
                    _active={{
                      bgGradient: "linear(to-r, teal.800, cyan.900)",
                    }}
                    onClick={() => {
                      setVisibleProducts((prev) => prev + 10);
                    }}
                  >
                    Load More Products
                  </Button>
                )}
              </Box>
            )}
          </TabPanel>
          
          {/* Posts Tab */}
          <TabPanel px={0}>
            {!profileData.posts || profileData.posts.length === 0 ? (
              <Box textAlign="center" py={10}>
                <Icon as={FaNewspaper} boxSize={12} color="gray.400" mb={4} />
                <Heading size="md" color="gray.500" mb={2}>No Posts Yet</Heading>
                <Text color="gray.500">{profileData.name} hasn't shared any posts yet.</Text>
              </Box>
            ) : (
              <VStack spacing={4} align="stretch">
                {profileData.posts.map((post, index) => (
                  <PostCard key={index} post={post} />
                ))}
              </VStack>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
}
